<template>
  <div class="city-electricity" v-if="data && data.upData.length > 0">
    <div class="up">
      <div class="left">
        <div class="c-number">{{ data.upData[0].number }}</div>
        <div class="c-title">{{ data.upData[0].title }}</div>
      </div>
      <div class="right">
        <div class="c-number">{{ data.upData[1].number }}</div>
        <div class="c-title">{{ data.upData[1].title }}</div>
      </div>
    </div>
    <div class="down" v-if="data && data.downData.length > 0 && data.downData[0].length > 0">
      <ul>
        <li>
          <span v-if="data.downData[0][0]">
            <span>{{ data.downData[0][0].title }}</span>
            <span>{{ data.downData[0][0].number }}</span>
          </span>
        </li>
        <li>
          <span v-if="data.downData[0][1]">
            <span>{{ data.downData[0][1].title }}</span>
            <span>{{ data.downData[0][1].number }}</span>
          </span>
        </li>
        <li>
          <span v-if="data.downData[0][2]">
            <span>{{ data.downData[0][2].title }}</span>
            <span>{{ data.downData[0][2].number }}</span>
          </span>
        </li>
      </ul>
      <ul>
        <li>
          <span v-if="data.downData[1][0]">
            <span>{{ data.downData[1][0].title }}</span>
            <span>{{ data.downData[1][0].number }}</span>
          </span>
        </li>
        <li>
          <span v-if="data.downData[1][1]">
            <span>{{ data.downData[1][1].title }}</span>
            <span>{{ data.downData[1][1].number }}</span>
          </span>
        </li>
        <li>
          <span v-if="data.downData[1][2]">
            <span>{{ data.downData[1][2].title }}</span>
            <span>{{ data.downData[1][2].number }}</span>
          </span>
        </li>
      </ul>
      <ul>
        <li>
          <span v-if="data.downData[2][0]">
            <span>{{ data.downData[2][0].title }}</span>
            <span>{{ data.downData[2][0].number }}</span>
          </span>
        </li>
        <li>
          <span v-if="data.downData[2][1]">
            <span>{{ data.downData[2][1].title }}</span>
            <span>{{ data.downData[2][1].number }}</span>
          </span>
        </li>
        <li>
          <span v-if="data.downData[2][2]">
            <span>{{ data.downData[2][2].title }}</span>
            <span>{{ data.downData[2][2].number }}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: [Object, Array],
      default() {
        return {
          upData: [{ number: '255,66', title: '正向有功总电能(kWh)' }, { number: '220', title: '反向有功总电能(kWh)' }],
          downData: []
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    init() {}
  },
  created() {
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.city-electricity {
  height: 100%;
  width: 100%;
  .up{
	  display: flex;
	  justify-content: space-between;
    height: 47px;
    margin-top: 20px;
	  .left{
		  width: 190px;
      height: 100%;
		  background: url(/static/images/svolt/nanwang/city-electricity-bj1.png) no-repeat center;
      background-size: 100%;
		  .c-number{
        height: 32px;
        font-size: 20px;
        font-weight: bold;
        line-height: 32px;
        margin-left:50px;
        margin-top:-2px;
        color: #08265F;
        font-family: DINBold, DINAlternate;
		  }
		  .c-title{
        height: 16px;
        font-size: 12px;
        margin-left:50px;
        margin-top:-3px;
        overflow: hidden;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #5E688F;
        text-align: left;
		  }
	  }
	  .right{
		  width: 190px;
      height: 100%;
		  background: url(/static/images/svolt/nanwang/city-electricity-bj2.png) no-repeat center;
      background-size: 100%;
		  .c-number{
        height: 32px;
        font-size: 20px;
        font-weight: bold;
        line-height: 32px;
        margin-left:50px;
        margin-top:-2px;
        color: #08265F;
        font-family: DINBold, DINAlternate;
		  }
		  .c-title{
        height: 16px;
        font-size: 12px;
        margin-left:50px;
        margin-top:-3px;
        overflow: hidden;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #5E688F;
		  }
	  }
  }
  .down{
    border: 1px solid #7FA0EE;
    border-radius: 6px;
    height: 86px;
    margin-top: 30px;
	  ul{
      border-bottom: 1px solid #7FA0EE;
      display: flex;
      height: 28px;
      width: 100%;
      box-sizing: border-box;
		  li{
        flex:1;
        text-align:center;
        line-height: 24px;
        position: relative;
        // border-right: 1px solid #144E9E;
        &:after {
                content: '';
                position: absolute;
                left: auto;
                top: auto;
                bottom: 7px;
                right: 0;
                height: 52%;
                width: 1px;
                background-color: #7FA0EE;
            }
        box-sizing: border-box;
        &:nth-last-child(1){
          &:after {
                  content: '';
                  position: absolute;
                  left: auto;
                  top: auto;
                  bottom: 7px;
                  right: 0;
                  height: 52%;
                  width: 0px;
                  background-color: #7FA0EE;
              }
        }
        span:nth-child(1){
          display: inline-block;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: #3F485B;
          line-height: 16px;
          margin:0px 2px;
        }
        span:nth-child(2){
          display: inline-block;
          position: relative;
          font-family: DINBold, DINAlternate;
          font-weight: 600;
          color: #76DEFC;
          margin:0px 2px;
          top:2px;
          font-size: 18px;
          font-weight: bold;
          color: #0F2C63;
        }
		  }
      &:nth-last-child(1){
        border-bottom: 0px;
      }
	  }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/city-electricity.vue